import { action } from 'typesafe-actions';

import { CountryAutoComplete } from 'models/countryAutoComplete';

export const COUNTRIES_AUTO_COMPLETE_REQUEST = 'COUNTRIES_AUTOCOMPLETE_REQUEST';
export const COUNTRIES_AUTO_COMPLETE_SUCCESSFUL = 'COUNTRIES_AUTOCOMPLETE_SUCCESSFUL';
export const COUNTRIES_AUTO_COMPLETE_FAILURE = 'COUNTRIES_AUTOCOMPLETE_FAILURE';

export const countriesAutoCompleteRequest = () => action(COUNTRIES_AUTO_COMPLETE_REQUEST);

export const countriesAutoCompleteSuccessful = (countries: CountryAutoComplete[]) => action(COUNTRIES_AUTO_COMPLETE_SUCCESSFUL, countries);

export const countriesAutoCompleteError = (error: string) => action(COUNTRIES_AUTO_COMPLETE_FAILURE, error);
